export enum OrgType {
    non_federated_org = 0,
    federated_org = 1,
}
